import QuanLyKho from "../component/quan-ly-kho/QuanLyKho";
import PhanHeDieuChuyen from "../phan-he-dieu-chuyen/PhanHeDieuChuyen";
import PhanHeNhapKho from "../phan-he-nhap-kho/PhanHeNhapKho";
import BoSungCoSoTuTruc from "../phan-he-tu-truc/components/BoSungCoSoTuTruc";
import PhanHeXuatKho from "../phan-he-xuat-kho/PhanHeXuatKho";
import {CODE_FORM, LOAI_CHUC_NANG, MATERIALS_GROUP, TYPE_WH, WAREHOUSE_ID} from "../utils/Constant";
import DuTruBoSungVTKho from "../du-tru-bo-sung-vat-tu-kho/DuTruBoSungVTKho";
import TongHopBoSungVatTu from "../TongHopBoSungVatTu";
import HoanTraVatTu from "../phan-he-tu-truc/components/HoanTraVatTu";
import { isCheckFuncWms } from "../utils/AppFunction";
import NhapBuCoSoTuTruc from "../phan-he-tu-truc/components/NhapBuCoSoTuTruc/NhapBuCoSoTuTruc";

export const danhSachTabKhoVatTu = (typeKho?: any, listCodeCN?: any) => [
    {
        eventKey: "0",
        title: "Xem tồn kho",
        component: <QuanLyKho
            materialsGroup={MATERIALS_GROUP.VAT_TU}
            warehouseId={typeKho?.id}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.NHAP_KHO) && {
        eventKey: "1",
        title: "Nhập kho",
        component: <PhanHeNhapKho
            warehouseId={typeKho?.id}
            typeKho={typeKho?.warehouseType}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.XUAT_KHO) && {
        eventKey: "2",
        title: "Xuất kho",
        component: <PhanHeXuatKho
            warehouseId={typeKho?.id}
            typeKho={typeKho?.warehouseType}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.DIEU_CHUYEN) && {
        eventKey: "3",
        title: "Điều chuyển",
        component: <PhanHeDieuChuyen
            warehouseId={typeKho?.id}
            typeKho={typeKho?.warehouseType}
            className="h-bang-ds-phieu-bao-hiem"
        />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.LINH_TU_TRUC) && {
        eventKey: "4",
        title: "Lĩnh về tủ trực",
        component: <BoSungCoSoTuTruc modelId={{
            id: CODE_FORM.BO_SUNG_CO_SO_TU_TRUC,
            type: TYPE_WH.BO_SUNG_CO_SO_TU_TRUC,
            name: 'Danh sách vật tư',
            title: '',
            whIssueId: typeKho?.id,
            className: "h-bang-ds-phieu-bao-hiem",
        }} />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.HOAN_TRA_TU_KHOA_PHONG) && {
        eventKey: "5",
        title: "Hoàn trả từ khoa/phòng",
        component: <HoanTraVatTu
            modelId={{
                id: CODE_FORM.HOAN_TRA_VAT_TU,
                type: TYPE_WH.TRANSFER,
                name: 'Hoàn trả vật tư',
                title: 'phiếu hoàn trả vật tư',
                className: "h-bang-ds-phieu-bao-hiem",
            }}
            onlyNhapKho={true}
            typeWf={2}
            warehouseId={typeKho?.id}

        />,
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.DU_TRU_BO_SUNG_VAT_TU) && {
        eventKey: "6",
        title: "Dự trù bổ sung vật tư",
        component: <DuTruBoSungVTKho warehouseId={typeKho?.id} />
    },
    isCheckFuncWms(listCodeCN, LOAI_CHUC_NANG.NHAP_BU_CO_SO_TU_TRUC) && {
        eventKey: "7",
        title: "Nhập bù cơ số tủ trực",
        component: <NhapBuCoSoTuTruc modelId={{
            id: CODE_FORM.NHAP_BU_CO_SO_TU_TRUC,
            type: TYPE_WH.NHAP_BU_CO_SO_TU_TRUC,
            name: 'Nhập bù cơ số tủ trực',
            title: '',
        }} />,
    },
];


export { };